"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import Image from "@/components/common/image/image";
import BaseLink from "@/components/common/base-link/base-link";
import ArrowIcon, { ArrowIconStyle } from "@/components/common/arrow-icon/arrow-icon";
import CurvedUnderline from "@/components/common/curved-underline/curved-underline";
import { useGtm } from "@/hooks/useGtm";
export const FINANCIAL_HEALTH_CHECKUP_HREF = "https://apply.amerisave.com/quote/v1/financial-health-checkup";
export const AS202_CASHOUT_HREF = "https://apply.amerisave.com/quote/v1/cashout";
export const AS202_BANNER_HREF_BY_VARIANT: Record<string, string> = {
  v1: FINANCIAL_HEALTH_CHECKUP_HREF,
  v2: AS202_CASHOUT_HREF,
  v3: `${AS202_CASHOUT_HREF}?FinHealth=On`
};
interface FinancialHealthBannerProps {
  experimentId?: "AS202";
  dma?: string;
  dmaGroup?: string;
  variationKey?: string;
  href?: string;
}
const FinancialHealthBanner = t0 => {
  const $ = _c(26);
  const {
    experimentId: t1,
    dma: t2,
    dmaGroup: t3,
    variationKey: t4,
    href: t5
  } = t0;
  const experimentId = t1 === undefined ? "AS202" : t1;
  const dma = t2 === undefined ? "" : t2;
  const dmaGroup = t3 === undefined ? "" : t3;
  const variationKey = t4 === undefined ? "v1" : t4;
  const href = t5 === undefined ? FINANCIAL_HEALTH_CHECKUP_HREF : t5;
  const {
    trackCustom
  } = useGtm();
  const impressionTracked = useRef(false);
  let t6;
  if ($[0] !== experimentId) {
    t6 = experimentId.toLowerCase();
    $[0] = experimentId;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const eventPrefix = t6;
  let t7;
  let t8;
  if ($[2] !== dma || $[3] !== dmaGroup || $[4] !== eventPrefix || $[5] !== experimentId || $[6] !== trackCustom || $[7] !== variationKey) {
    t7 = () => {
      if (impressionTracked.current) {
        return;
      }
      impressionTracked.current = true;
      trackCustom(`${eventPrefix}-banner-impression`, {
        experimentId,
        variationKey,
        dma,
        dmaGroup,
        exposedVsHoldoutStatus: dmaGroup,
        eventCategory: "homepage-banner"
      });
    };
    t8 = [trackCustom, dma, dmaGroup, eventPrefix, experimentId, variationKey];
    $[2] = dma;
    $[3] = dmaGroup;
    $[4] = eventPrefix;
    $[5] = experimentId;
    $[6] = trackCustom;
    $[7] = variationKey;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  useEffect(t7, t8);
  const ctaValue = href === FINANCIAL_HEALTH_CHECKUP_HREF ? "financial-health-checkup" : "cashout";
  let t9;
  if ($[10] !== dma || $[11] !== dmaGroup || $[12] !== eventPrefix || $[13] !== experimentId || $[14] !== href || $[15] !== trackCustom || $[16] !== variationKey) {
    t9 = () => {
      trackCustom(`${eventPrefix}-banner-click`, {
        experimentId,
        variationKey,
        dma,
        dmaGroup,
        exposedVsHoldoutStatus: dmaGroup,
        eventCategory: "homepage-banner",
        ctaLabel: "Get Started",
        destination: href
      });
    };
    $[10] = dma;
    $[11] = dmaGroup;
    $[12] = eventPrefix;
    $[13] = experimentId;
    $[14] = href;
    $[15] = trackCustom;
    $[16] = variationKey;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const handleClick = t9;
  const t10 = `${eventPrefix}-banner`;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Image src="/financial-health-robot.png" alt="Financial Health Checkup" width={84} height={67} className="h-[53px] w-[67px] shrink-0 object-contain lg:h-[67px] lg:w-[84px]" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex min-w-0 flex-1 flex-col gap-2 lg:gap-3"><h3 className="font-work-sans text-xl font-semibold leading-[30px] tracking-[-0.4px] text-[#373B37] lg:text-2xl lg:leading-[23px] lg:tracking-[-0.48px]">Check Your Financial Health</h3><p className="font-work-sans text-base font-normal leading-6 text-[#4A4A4A] lg:font-medium lg:leading-[22px]">Get personalized insights about your financial situation and find opportunities to lower your rates, get cash, and save money.</p></div>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="relative inline-flex shrink-0 items-center font-work-sans text-base font-semibold tracking-[-0.08px] text-[#373B37]">Get Started<ArrowIcon style={ArrowIconStyle.SECONDARY} width={16} height={16} /><CurvedUnderline color="#373B37" /></span>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== ctaValue || $[22] !== handleClick || $[23] !== href || $[24] !== t10) {
    t14 = <BaseLink href={href} onClick={handleClick} data-cta-id={t10} data-cta-value={ctaValue} className="group flex flex-col gap-6 rounded-lg bg-[#F2F8FB] p-6 lg:flex-row lg:items-center lg:gap-6 lg:p-8">{t11}{t12}{t13}</BaseLink>;
    $[21] = ctaValue;
    $[22] = handleClick;
    $[23] = href;
    $[24] = t10;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
export default FinancialHealthBanner;